import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Grid, Typography, Avatar } from '@material-ui/core';
import LoyaltyIcon from '@material-ui/icons/Loyalty';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
  },
  content: {
    alignItems: 'center',
    display: 'flex',
  },
  title: {
    fontWeight: 700,
  },
  avatar: {
    backgroundColor: theme.palette.pink,
    height: 56,
    width: 56,
  },
  icon: {
    height: 32,
    width: 32,
  },
  pledges: {
    marginTop: '10%',
    marginBottom: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifySelf: 'flex-end',
  },
  pledgesValue: {
    fontWeight: 500,
  },
}));

const TotalClusters = props => {
  const { className, clustersFunded, totalClusters, ...rest } = props;

  const classes = useStyles();

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent>
        <Grid container justify="space-between">
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              TOTAL CLUSTERS PLEDGED
            </Typography>
            <Typography variant="h3">{clustersFunded}</Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <LoyaltyIcon className={classes.icon} />
            </Avatar>
          </Grid>
        </Grid>
        <div className={classes.pledges}>
          <Typography variant="body2">
            <span className={classes.pledgesValue}>{clustersFunded}</span> of{' '}
            {totalClusters} clusters pledged
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
};

TotalClusters.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  totalClusters: PropTypes.number.isRequired,
  clustersFunded: PropTypes.number.isRequired,
};

export default TotalClusters;
